import { getStrCharLen } from "@/utils";

export default {
  data() {
    // 校验单位名称
    const validateAppliName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入单位名称"));
      }
      if (getStrCharLen(value) > 60) {
        return callback(new Error("单位名称最多30字"));
      }
      callback();
    };
    // 校验证件号码
    const validateIdentifyNumber = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入证件号码"));
      }
      if (getStrCharLen(value) > 20) {
        return callback(new Error("证件号码长度最多20个字符"));
      }
      if (/[\u4E00-\u9FA5]/g.test(value)) {
        return callback(new Error("证件号码不能含有中文"));
      }
      callback();
    };
    // 校验证件有效期
    const validateEfficientDate = (rule, value, callback) => {
      if (this.longEffective) {
        callback();
      } else {
        if (!value) {
          callback(new Error("请选择证件有效期"));
        } else {
          callback();
        }
      }
    };
    // 校验联系人姓名
    const validateLinkerName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入联系人姓名"));
      }
      if (!/^[\u4e00-\u9fa5]{2,4}$/.test(value)) {
        return callback(new Error("联系人姓名请输入2～4个中文汉字"));
      }
      callback();
    };
    // 校验法人姓名
    // const validateLegalName = (rule, value, callback) => {
    //   if (!value) {
    //     return callback(new Error("请输入法人姓名"));
    //   }
    //   if (!/^[\u4e00-\u9fa5]{2,4}$/.test(value)) {
    //     return callback(new Error("法人姓名请输入2～4个中文汉字"));
    //   }
    //   callback();
    // };
    // 校验联系人电话
    const validatePhoneNumber = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入联系人电话"));
      }
      if (
        !/^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/.test(
          value
        )
      ) {
        return callback(new Error("请输入正确的手机号码"));
      }
      callback();
    };
    // 校验经营地址
    const validateAppliAddress = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入经营地址"));
      }
      if (getStrCharLen(value) > 200) {
        return callback(new Error("经营地址最多100个字"));
      }
      callback();
    };
    // 校验银行账号
    const validateAccountCode = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入收款银行账号"));
      }
      if (!/^[0-9]{1,30}$/.test(value)) {
        return callback(new Error("请输入正确的银行卡号"));
      }
      callback();
    };
    // 校验收款人姓名
    const validateAccountName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入被保险人被保险人"));
      }
      if (getStrCharLen(value) > 40) {
        return callback(new Error("投保人/被保险人最多40个字符"));
      }
      callback();
    };
    return {
      rules: {
        appliName: [
          {
            required: true,
            validator: validateAppliName,
            trigger: "blur",
          },
        ],
        appliType: [
          {
            required: true,
            message: "请选择单位类型",
            trigger: "change",
          },
        ],
        // legalPerson: [
        //   {
        //     required: true,
        //     validator: validateLegalName,
        //     trigger: "blur",
        //   },
        // ],
        identifyType: [
          { required: true, message: "请选择证件类型", trigger: "change" },
        ],
        identifyNumber: [
          {
            required: true,
            validator: validateIdentifyNumber,
            trigger: "blur",
          },
        ],
        validDate: [
          {
            required: true,
            message: "请选择证件有效期",
            validator: validateEfficientDate,
            trigger: "change",
          },
        ],
        linkerName: [
          {
            required: true,
            validator: validateLinkerName,
            trigger: "blur",
          },
        ],
        phoneNumber: [
          {
            required: true,
            validator: validatePhoneNumber,
            trigger: "blur",
          },
        ],
        appliAddress: [
          {
            required: true,
            validator: validateAppliAddress,
            trigger: "blur",
          },
        ],
        comCode: [
          { required: true, message: "请选择投保机构", trigger: "change" },
        ],
        accountName: [
          {
            required: true,
            validator: validateAccountName,
            trigger: "blur",
          },
        ],
        accountCode: [
          {
            required: true,
            validator: validateAccountCode,
            trigger: "blur",
          },
        ],
        bankName: [
          { required: true, message: "请选择银行", trigger: "change" },
        ],
        bankBranchName: [
          { required: true, message: "请选择开户支行", trigger: "change" },
        ],
        insuredIdentifyType: [
          { required: true, message: "被保险人证件类型", trigger: "change" },
        ],
        insuredIdentifyNumber: [
          { required: true, message: "被保险人证件号码", trigger: "blur" },
        ],
        insuredValidEndDate: [
          { required: true, message: "被保险人证件号码", trigger: "change" },
        ],
        insuredAddressCName: [
          { required: true, message: "被保险人地址", trigger: "blur" },
        ],
      },
    };
  },
};
